import {useAuth} from '../app/modules/auth'

export function flattenObject(
  obj: Record<string, any>,
  prefix = '',
  result: Record<string, any> = {}
) {
  if (Array.isArray(obj)) {
    obj.forEach((item, index) => {
      flattenObject(item, `${prefix}[${index}]`, result)
    })
  } else if (typeof obj === 'object' && obj !== null) {
    for (let key in obj) {
      flattenObject(obj[key], prefix ? `${prefix}.${key}` : key, result)
    }
  } else {
    result[prefix] = obj
  }
  return result
}
export function getValues(obj: any) {
  const result: string[] = []

  function recurse(value: any) {
    if (value && typeof value === 'object') {
      for (const key in value) {
        recurse(value[key])
      }
    } else {
      result.push(String(value))
    }
  }

  recurse(obj)
  return result
}

export const useCurrencySymbol = () => {
  const {school} = useAuth()
  const formatAmount = (amount: number = 0) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: school?.currency || 'NGN',
    }).format(amount)
  }
  return {
    formatAmount,
  }
}
